/**
 * GiftCardDetailField — a labeled value in the summary card (BON-223): a
 * small uppercase caption over the value, used for Source/Created.
 */
import type { ReactNode } from 'react';

export function GiftCardDetailField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 800,
          letterSpacing: '.06em',
          textTransform: 'uppercase',
          color: 'var(--nb-subtle)',
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 13 }}>{children}</div>
    </div>
  );
}
